import { render, staticRenderFns } from "./PatientControlIdentification.vue?vue&type=template&id=9db94c12&scoped=true&"
import script from "./PatientControlIdentification.vue?vue&type=script&lang=ts&"
export * from "./PatientControlIdentification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db94c12",
  null
  
)

export default component.exports